import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAReportsComplete() {
  const { powerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../report-frequency');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../personal-benefit');
  }, [ navigate ]);
  
  return (
    <div className="new-poa-reports-complete screen-container screen">
      <ScreenHeader
        title="Requiring Period Reports Complete"
        description="Review your reporting requirements"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <div className="completion-summary">
          <div className="summary-card">
            <div className="summary-icon">📋</div>
            <div className="summary-content">
              <h3>Reporting Requirements Complete</h3>
              <p>You have successfully configured reporting requirements for your agent.</p>
            </div>
          </div>

          <div className="reports-overview">
            <h3>Your Reporting Settings</h3>
            
            {powerOfAttorney.require_period_reports ? (
              <div className="reports-enabled">
                <div className="setting-item">
                  <span className="setting-label">Period Reports:</span>
                  <span className="setting-value enabled">Required</span>
                </div>
                
                <div className="setting-item">
                  <span className="setting-label">Frequency:</span>
                  <span className="setting-value">
                    {powerOfAttorney.report_frequency === 'quarterly' ? 'Quarterly (Every 3 months)' : 'Semi-annually (Every 6 months)'}
                  </span>
                </div>

                {powerOfAttorney.report_recipients && powerOfAttorney.report_recipients.length > 0 && (
                  <div className="setting-item">
                    <span className="setting-label">Recipients:</span>
                    <div className="recipients-list">
                      {powerOfAttorney.report_recipients.map((recipient, index) => (
                        <div key={index} className="recipient-summary">
                          {recipient.name}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="reports-benefits">
                  <h4>Benefits of Your Reporting Requirements:</h4>
                  <ul>
                    <li>Regular oversight of your agent's activities</li>
                    <li>Transparency for family members and trusted individuals</li>
                    <li>Early detection of potential issues</li>
                    <li>Clear record of financial transactions</li>
                  </ul>
                </div>
              </div>
            ) : (
              <div className="reports-disabled">
                <div className="setting-item">
                  <span className="setting-label">Period Reports:</span>
                  <span className="setting-value disabled">Not Required</span>
                </div>
                <p>
                  You have chosen not to require period reports from your agent. 
                  Your agent will still have a duty to act in your best interests 
                  and maintain records of their activities.
                </p>
              </div>
            )}

            <div className="next-steps">
              <h3>Next Steps</h3>
              <p>
                Continue to configure additional options for your Power of Attorney, 
                including task delegation and agent compensation settings.
              </p>
            </div>
          </div>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
